export const PLATFORM_BASE =
  (import.meta.env.VITE_PLATFORM_BASE as string | undefined)?.replace(/\/$/, "") ||
  "/platform";

export const RELAY_URL =
  (import.meta.env.VITE_RELAY_URL as string | undefined) ||
  `${location.protocol === "https:" ? "wss" : "ws"}://${location.host}`;

export const FREE_NEURONS_PER_DAY = 10_000;

export interface AiUsage {
  usedNeurons: number;
  freeAllotment: number;
  remainingNeurons: number;
  resetAtUtc: string;
  percentUsed: number;
  nearLimit: boolean;
  atLimit: boolean;
  source: string;
}

export interface KillSwitchStatus {
  active: boolean;
  checkedAt: string;
  source: string;
}

export interface RiskSnapshot {
  version: number;
  cryptoDefaultEntryUsd: number;
  kalshiMaxRiskPerOrderUsd: number;
  alpacaSinglePositionRiskCapPct: number;
}

export async function fetchJson<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`${PLATFORM_BASE}${path}`, {
    ...init,
    headers: {
      Accept: "application/json",
      ...(init?.headers ?? {}),
    },
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || `HTTP ${response.status}`);
  }
  return (await response.json()) as T;
}
